<div>
  <b>Project End Date</b>
  <br/>
  <dw-readonly [(ngModel)]="selectedDate" formatType="date"></dw-readonly>
</div>
